import type { ContentItem } from "../content/types";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { ButtonLink } from "../components/ButtonLink";
import { RichContent } from "../components/RichContent";
import { formatDate } from "../lib/article";

type StandardPageProps = { page: ContentItem };

export function StandardPage({ page }: StandardPageProps) {
  const nextSteps = page.slug === "next-steps";

  return (
    <article className="standard-page">
      <header className="page-head">
        <div className="wrap page-head__narrow">
          <Breadcrumbs crumbs={[{ label: "Home", href: "/" }, { label: page.title }]} />
          <p className="index-label">
            <span className="index-label__number">{nextSteps ? "Checklist" : "Aquarium Helpline"}</span>
            <span>Reviewed {formatDate(page.modifiedAt)}</span>
          </p>
          <h1 className="display">{page.title}</h1>
        </div>
      </header>
      <div className="standard-page__body wrap">
        <RichContent html={page.contentHtml} />
        <aside className="standard-page__action">
          <h2 className="display">{nextSteps ? "Still need to book your call?" : "Ready to show us the tank?"}</h2>
          <p>{nextSteps ? "Send your aquarium details and preferred availability." : "A focused 15-minute review can save time, reduce unnecessary purchases, and help you avoid compounding the problem."}</p>
          <ButtonLink href="/consultation/">Request a 15-minute consultation</ButtonLink>
        </aside>
      </div>
    </article>
  );
}
